import { render, staticRenderFns } from "./InputTextWithSuggestion.vue?vue&type=template&id=733c5476&scoped=true"
import script from "./InputTextWithSuggestion.vue?vue&type=script&lang=ts"
export * from "./InputTextWithSuggestion.vue?vue&type=script&lang=ts"
import style0 from "./InputTextWithSuggestion.vue?vue&type=style&index=0&id=733c5476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c5476",
  null
  
)

export default component.exports